import { ListChecks } from "lucide-react";

const STYLE = {
  proceed: ["Proceed", "bg-emerald-50 text-emerald-800 border-emerald-200"],
  precautions: ["Proceed with precautions", "bg-sky-50 text-sky-800 border-sky-200"],
  pending: ["Information needed first", "bg-amber-50 text-amber-800 border-amber-200"],
  clearance: ["Specialist clearance", "bg-orange-50 text-orange-800 border-orange-200"],
  defer: ["Defer", "bg-red-50 text-red-800 border-red-200"],
};

export function TreatmentPlan({ plan }) {
  if (!plan || plan.length < 2) return null;
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 mb-4" data-testid="treatment-plan">
      <p className="font-heading font-semibold text-[#0B2545] flex items-center gap-2"><ListChecks className="w-4 h-4" /> Treatment plan — decision per procedure</p>
      <ul className="mt-3 divide-y divide-slate-100">
        {plan.map((p) => {
          const [label, cls] = STYLE[p.tier] || [p.tier, "bg-slate-50 text-slate-700 border-slate-200"];
          return (
            <li key={p.procedure_id} className="py-2 flex items-start justify-between gap-3" data-testid={`plan-row-${p.procedure_id}`}>
              <span className="text-sm text-slate-800 min-w-0">{p.procedure_name}{p.primary && <span className="ml-2 text-xs text-slate-400">(overall decision below)</span>}</span>
              <span className={`shrink-0 whitespace-nowrap text-xs font-semibold px-2.5 py-1 rounded-full border ${cls}`} data-testid={`plan-tier-${p.procedure_id}`}>{label}</span>
            </li>
          );
        })}
      </ul>
      <p className="text-xs text-slate-500 mt-2">The overall decision follows the highest-risk procedure; required tests and referrals are listed once.</p>
    </div>
  );
}
